import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["days"]

  connect() {
    // Filters are primarily handled by Turbo links
    // This controller can be extended for mobile filter drawer if needed
  }
}
